module.exports = __webpack_public_path__ + "img/162_thumbnail.e63703bd.jpg";